import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PlanSelection.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faRocket, faStar } from '@fortawesome/free-solid-svg-icons';

export default function PlanSelection() {
  const navigate = useNavigate();

  const handleSubscribeToSAI = () => {
    // Redirigir al checkout con el plan customer-sai
    navigate('/subscribe/customer-sai');
  };

  const handleSubscribeWithParams = () => {
    // Redirigir al checkout usando query params
    navigate('/subscribe?plan=customer-sai');
  };

  return (
    <div className="plan-selection">
      <Header />
      <div className="plan-selection-container">
        <div className="plan-selection-header">
          <h1>Elige tu Plan de Suscripción</h1>
          <p>Accede a herramientas avanzadas para hacer crecer tu negocio</p>
        </div>

        <div className="plans-grid">
          {/* Plan SAI */}
          <div className="plan-card featured">
            <div className="plan-badge">
              <FontAwesomeIcon icon={faStar} />
              Recomendado
            </div>
            <div className="plan-header">
              <h2>SAI Access</h2>
              <p>Sistema de Abonos Inteligentes</p>
            </div>
            <div className="plan-price">
              <span className="price">$75,000</span>
              <span className="period">/año</span>
            </div>
            <div className="plan-features">
              <ul>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Acceso completo a la plataforma SAI
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Simulación inteligente de abonos
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Gestión estratégica de proveedores
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Control de flujo de caja en tiempo real
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Soporte técnico especializado
                </li>
              </ul>
            </div>
            <button 
              onClick={handleSubscribeToSAI}
              className="subscribe-btn primary"
            >
              <FontAwesomeIcon icon={faRocket} />
              Suscribirse Ahora
            </button>
            <p className="plan-note">
              Perfecto para optimizar tus pagos y mejorar relaciones comerciales
            </p>
          </div>

          {/* Ejemplo con params */}
          <div className="plan-card">
            <div className="plan-header">
              <h2>SAI Access (Query Params)</h2>
              <p>Mismo plan, usando parámetros de URL</p>
            </div>
            <div className="plan-price">
              <span className="price">$75,000</span>
              <span className="period">/año</span>
            </div>
            <div className="plan-features">
              <ul>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Mismo acceso completo a SAI
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} />
                  Ejemplo de implementación alternativa
                </li>
              </ul>
            </div>
            <button 
              onClick={handleSubscribeWithParams}
              className="subscribe-btn secondary"
            >
              Suscribirse (Query Params)
            </button>
            <p className="plan-note">
              Ejemplo usando ?plan=customer-sai
            </p>
          </div>
        </div>

        <div className="promo-section">
          <div className="promo-card">
            <h3>🎉 ¡Código Promocional Disponible!</h3>
            <p>Usa el código <strong>SAI2025</strong> para obtener <strong>100% de descuento</strong></p>
            <p className="promo-note">Válido hasta el 15 de Agosto, 2025</p>
          </div>
        </div>

        <div className="benefits-section">
          <h2>¿Por qué elegir el Sistema SAI?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <h3>🎯 Optimización Financiera</h3>
              <p>Maximiza el impacto de cada peso invertido en pagos a proveedores</p>
            </div>
            <div className="benefit-item">
              <h3>📊 Control Total</h3>
              <p>Visualiza y controla tu flujo de caja en tiempo real</p>
            </div>
            <div className="benefit-item">
              <h3>🚀 Ahorro de Tiempo</h3>
              <p>Automatiza cálculos complejos y toma decisiones más rápidas</p>
            </div>
            <div className="benefit-item">
              <h3>🤝 Mejores Relaciones</h3>
              <p>Mantén relaciones sólidas con proveedores mediante pagos estratégicos</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
